import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { getECommerceOffer } from "./eCommerceApi";

export const useEcommerceOffer = () => {
  const { eCommerceOfferId } = useParams<{ eCommerceOfferId: string }>();
  const { data, isLoading } = useQuery({
    queryKey: ["e-commerce", eCommerceOfferId],
    queryFn: ({ signal }) => getECommerceOffer(eCommerceOfferId!, signal),
    enabled: eCommerceOfferId !== undefined,
  });
  return { offerId: eCommerceOfferId, data, isLoading };
};
